import * as React from 'react';
import * as debounce from 'lodash.debounce';

import CategoriesFilter from 'src/components/CategoriesFilter';
import ProductCatalogBox from 'src/components/ProductCatalogBox';

import './Categories.scss';
import SubcategoryModel from 'src/model/subcategory.model';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import CustomPaginator from 'src/components/common/CustomPaginator';
// import ProductModel from 'src/model/product.model';

class Categories extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentScroll: true
    };
  }

  private handlePageChange = (event: any) => {
    const debouncedService = debounce(() => {
      if (this.props.activeFilters && this.props.activeFilters.length) {
        this.props.getFilteredProducts(
          this.props.match.params.subcategoryId.toString(),
          this.props.activeFilters,
          event - 1,
          this.props.paginator.pageSize
        );
      } else {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount,
          event - 1,
          this.props.paginator.pageSize
        );
      }
      window.scrollTo(0, 0);
    }, 1000);
    debouncedService();
  };

  private handlePageSizeChange = (event: any) => {
    const debouncedService = debounce(() => {
      if (this.props.activeFilters && this.props.activeFilters.length) {
        this.props.getFilteredProducts(
          this.props.match.params.subcategoryId.toString(),
          this.props.activeFilters,
          0,
          event
        );
      } else {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount,
          0,
          event
        );
      }
      window.scrollTo(0, 0);
    }, 1000);
    debouncedService();
  };

  private onRouteChanged() {
    const empty: any = [];
    this.props.getCategories(this.props.match.params.categoryId);
    this.props.setActiveFilters(empty);
    this.props.getSubcategoriesFilters(this.props.match.params.subcategoryId);
    this.props.getProductsBySubCategory(
      this.props.match.params.subcategoryId,
      this.props.activeAccount
    );
    // if (this.props.activeFilters && this.props.activeFilters.length) {
    //   debugger;
    //   this.props.getFilteredProducts(
    //     this.props.match.params.subcategoryId.toString(),
    //     this.props.activeFilters
    //   );
    // } else {
    //   this.props.getProductsBySubCategory(
    //     this.props.match.params.subcategoryId,
    //     this.props.activeAccount
    //   );
    // }
  }

  private getSelectedSubcategory() {
    const found = this.props.subcategories.find(
      (sub: SubcategoryModel) =>
        sub.id === parseInt(this.props.match.params.subcategoryId, 10)
    );
    return found;
  }

  private renderTitle() {
    const subcategory = this.getSelectedSubcategory();
    if (!subcategory) {
      return <div />;
    }
    return (
      <div className="rp-categories-page--title roboto">
        <span className='span-blue'>
        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.category.frName!== null 
            ?subcategory.category.frName
            :subcategory.category.name}
        </span>
        <i className="rpds rpds-chevron-right" />
        <span className='span-green'>
        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName!== null 
            ?subcategory.frName
            :subcategory.name}
        </span>
        <div className="categories-paginator-container">
          <CustomPaginator
            activePage={
              this.props.paginator.pageNumber
                ? this.props.paginator.pageNumber + 1
                : 1
            }
            totalPages={this.props.paginator.totalPages}
            itemsPerPage={this.props.paginator.pageSize}
            onPageChanged={this.handlePageChange}
            totalItems={
              this.props.paginator.totalPages * this.props.paginator.pageSize
            }
            showPageInfo={true}
            showPageRangeChange={false}
            currentPageSize={this.props.paginator.pageSize}
            onPageSizeChange={this.handlePageSizeChange}
          />
        </div>
      </div>
    );
  }

  private handleContentScroll = (shouldScroll: boolean) => {
    this.setState({ contentScroll: shouldScroll });
  };

  private handleFilters = (
    newFilter: SubcategoryFilter,
    action: 'add' | 'remove'
  ) => {
    if (action === 'add') {
      // console.log('actionaddd', newFilter)
      this.props.setActiveFilters([...this.props.activeFilters, newFilter]);
    } else {
      const newFilters = this.props.activeFilters.filter(
        (filter: SubcategoryFilter) => filter !== newFilter
      );
      // console.log('action', newFilters);
      // console.log('action', newFilters.length);
      this.props.setActiveFilters([...newFilters]);
      // console.log(newFilters.length)
      if (newFilters.length === 0) {
        this.props.getProductsBySubCategory(
          this.props.match.params.subcategoryId,
          this.props.activeAccount
        );
      }
    }
  };

  private sortProductsWithImages = (productArray: ProductModel[]) => {
    if (productArray.length !== 0) {
      // Sort products to show the ones with images first
      return productArray.sort((a: any, b: any) => {
        if (a.imageUrls !== null && a.imageUrls.length) {
          return 0;
        }
        if (b.imageUrls !== null && b.imageUrls.length) {
          return 1;
        }
        return 0;
      });
    } else {
      return productArray;
    }
  };

  private getDataSource = () => {
    if (this.props.activeFilters.length === 0) {
      const { products } = this.props;
      return this.sortProductsWithImages(products);
    } else {
      return this.sortProductsWithImages(this.props.filteredProducts);
    }
  };

  private handleToggleFavorite = (
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      listService.deleteItem(favoriteId).then(res => {
        if (this.props.activeFilters && this.props.activeFilters.length) {
          this.props.getFilteredProducts(
            this.props.match.params.subcategoryId.toString(),
            this.props.activeFilters
          );
        } else {
          this.props.getProductsBySubCategory(
            this.props.match.params.subcategoryId,
            this.props.activeAccount
          );
        }
      });
    } else {
      listService.addItem('favorites', name, mfc).then(res => {
        if (this.props.activeFilters && this.props.activeFilters.length) {
          this.props.getFilteredProducts(
            this.props.match.params.subcategoryId.toString(),
            this.props.activeFilters
          );
        } else {
          this.props.getProductsBySubCategory(
            this.props.match.params.subcategoryId,
            this.props.activeAccount
          );
        }
      });
    }
  };

  public componentDidMount() {
    this.props.getCategories(this.props.match.params.categoryId);

    this.props.getSubcategoriesFilters(this.props.match.params.subcategoryId);
    if (this.props.activeFilters && this.props.activeFilters.length) {
      this.props.getFilteredProducts(
        this.props.match.params.subcategoryId.toString(),
        this.props.activeFilters
      );
    } else {
      this.props.getProductsBySubCategory(
        this.props.match.params.subcategoryId,
        this.props.activeAccount
      );
    }
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }

    if (
      prevProps.activeFilters !== this.props.activeFilters &&
      this.props.activeFilters.length
    ) {
      this.props.getFilteredProducts(
        this.props.match.params.subcategoryId.toString(),
        this.props.activeFilters
      );
    }
  }

  public render() {
    const { t } = this.props;
    const contentScroll = this.state.contentScroll ? 'scroll' : 'no-scroll';

    return (
      <section id="rp-categories-page">
        <div className="rp-categories-page--filters">
          <CategoriesFilter
            selectedSubcategory={this.getSelectedSubcategory()}
            handleScroll={this.handleContentScroll}
            filtersPending={this.props.getSubcategoriesFilterIsPending}
            filters={this.props.filters}
            activeFilters={this.props.activeFilters}
            setFilters={this.handleFilters}
            clearFilters={this.props.setActiveFilters}
            getFilteredProducts={this.props.getFilteredProducts}
            isLoadingSubcategories={this.props.getSubcategoriesIsPending}
          />
        </div>
        <div className={`rp-categories-page--content ${contentScroll}`}>
          {this.renderTitle()}
          <ProductCatalogBox
            subcategory={this.getSelectedSubcategory()}
            products={this.getDataSource()}
            loading={this.props.getProductsIsPending}
            emptyMessage={t('common.emptySubcategory')}
            handlePageChange={this.handlePageChange}
            paginator={this.props.paginator}
            handleToggleFavorite={this.handleToggleFavorite}
            handlepageSizeChange={this.handlePageSizeChange}
          />
        </div>
      </section>
    );
  }
}

export default Categories;
